import { render } from "./AboutWelfare.vue?vue&type=template&id=3e23f874"
import script from "./AboutWelfare.vue?vue&type=script&lang=js"
export * from "./AboutWelfare.vue?vue&type=script&lang=js"

import "./AboutWelfare.vue?vue&type=style&index=0&id=3e23f874&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__